module.exports = __webpack_public_path__ + "static/clonex-c869e70a76fe76fbae19efd067cee53d.jpg";